/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceAssignmentState } from './resourceAssignmentState';


export interface ResourceAssignmentHistory { 
    vcf_org_id?: string;
    assignment_state?: ResourceAssignmentState;
    assigned_by?: string;
    assigned_time?: Date;
    unassigned_by?: string;
    unassigned_time?: Date;
}
export namespace ResourceAssignmentHistory {
}


